import React, { useEffect } from 'react'
import Header from '../Components/Header'
import { Avatar, Box, Container, Icon, IconButton, Typography } from '@mui/material'
import image from "../Image.jpg"
import Footer from '../Components/Footer'
import illustation from "../illustration.png"
import photo from "../PXL_20231009_125631885.jpg"
import Project from '../Components/Project'
import { LinkedIn, GitHub, Instagram, Facebook, Mail, Description, FormatQuote } from '@mui/icons-material'
import cover from "../cover1.jpg";
import ProjectsList from "../Data/Realisation.json";
import { t } from 'i18next'
import zero from '../african-american-worker-standing-uniform-wearing-safety-hat-factory.jpg'
import un from '../steel-bar-site-construction.jpg'
import deux from '../construction-engineer.jpg'


interface Props { }

function Projects(props: Props) {
    const { } = props

    return (
        <div style={{ backgroundColor: "inherit" }} >
            <Header /><br /><br />
            <Container style={{ height: '100%' }} className='conatainer'>
                <br />
                <Box className='profil' >
                    <Typography variant='h4' style={{ fontWeight: "bold" }} align='left'>
                        {"NOS PROJETS"}
                    </Typography>
                </Box><br />
                Découvrez quelques-uns de nos projets emblématiques qui témoignent de notre savoir-faire et de notre engagement.
                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {ProjectsList.map((f, index) => (
                        (index == 0 || index == 1 || index == 2) ? <Project logo={
                            index.toString() == '0' ? zero :
                                index.toString() == '1' ? un :
                                    deux
                        } link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.provider)} /> : ''
                    ))}
                </Box>
                <br /><br />
                <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                    {ProjectsList.map((f, index) => (
                        (index == 3 || index == 4 || index == 5) ? <Project logo={
                            index.toString() == '0' ? zero :
                                index.toString() == '1' ? un :
                                    index.toString() == '2' ? zero :
                                        index.toString() == '3' ? un :
                                            index.toString() == '4' ? zero :
                                                index.toString() == '5' ? un :
                                                   un
                        } link={f.link} linkName={t(f.title)} date={t(f.date)} title={t(f.title)} description={t(f.provider)} /> : ''
                    ))}
                </Box>
            </Container>
            <br /><br />
            <Footer />
        </div>
    )
}

export default Projects
